import * as React from 'react';
import IMembersPortalComponentDataItem from '../../../../redux/types/IMembersPortalComponentDataItem';
import { mp_addTab } from '../../../../redux/reducers/MembersPortalReducer';
import { MemberStatementUsageDetailsGrid } from '../statementDetailsGrid/MemberStatementUsageDetailsGrid';
import { IMemberStatementUsageDetailsState } from '../../../../redux/types/IMemberStatementState';


export interface IMemberStatementUsageDetailsPageProps {
    usageDetailsPageComponentData: IMembersPortalComponentDataItem;
    usageDetailsGridsComponentData: IMembersPortalComponentDataItem;
    addTab: typeof mp_addTab;
    usageDetails: IMemberStatementUsageDetailsState;
    userNameNumber: string;
}

export const MemberStatementUsageDetailsPage: React.FC<IMemberStatementUsageDetailsPageProps> = (props: IMemberStatementUsageDetailsPageProps) => {
    const [viewData, setViewData] = React.useState({});

    React.useEffect(() => {
        const {
            usageDetailsPageComponentData: { fields }
        } = props;
        let data = {}
        if (fields) {
            const visibleFields = fields.filter(field => !field.hidden);

            visibleFields.forEach(item => {
                data[item.name] = item.data;

                if (Object.keys(data).length === visibleFields.length) {
                    setViewData(data);
                }
            });
        }
    }, [])


    const { paymentRunCode, description, workNumber, distributionCode, poolCode, segment } = props.usageDetails ?? {};

    return(
        <div>
            <div><span className="title">{viewData['usageDetails']} {workNumber}</span></div>
            <div><span className='subtitle'>{viewData['payment']} {paymentRunCode}</span></div>
            <div><span>{description}</span></div>
            <br />
            <div className='dataRow'>
                <div>
                    <h3>{viewData['distributionCode']}</h3>
                    <div>{distributionCode}</div>
                </div>
                <div>
                    <h3>{viewData['poolCode']}</h3>
                    <div>{poolCode}</div>
                </div>
                {segment && (
                    <div>
                        <h3>{viewData['segment']}</h3>
                        <div>{segment}</div>
                    </div>
                )}
                <div>
                    <h3>{viewData['workNumber']}</h3>
                    <div>{workNumber}</div>
                </div>
            </div>


            <div>
                <MemberStatementUsageDetailsGrid
                    usageDetails={props.usageDetails}
                    userNameNumber={props.userNameNumber}
                    usageDetailsGridsComponentData={props.usageDetailsGridsComponentData}
                />
            </div>
            

        </div>
    )
}